import React from "react";

export default function CommunityBanner() {
  return (
    <section className="py-6 md:py-8 bg-[#f4f2fb]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden bg-[#1a0330]  min-h-[230px] flex items-center">
          {/* Sunset image full-bleed, smoke-faded from left */}
          <div className="absolute inset-0 z-0 pointer-events-none">
            <img
              src="https://images.unsplash.com/photo-1539635278303-d4002c07eae3?auto=format&fit=crop&w=1200&q=80"
              alt="Group of travelers watching sunset"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1a0330] from-10% via-[#1a0330]/70 via-45% to-transparent to-85%" />
          </div>

          {/* Banner content (left) */}
          <div className="relative z-10 px-6 py-5 md:px-8 lg:px-10 max-w-md text-white">
            <span className="text-[9px] font-bold text-violet-400 uppercase tracking-widest block mb-1.5">
              Community
            </span>

            <h2 className="text-lg md:text-xl font-extrabold leading-snug">
              Meet Amazing Travelers <br />
              Around the World
            </h2>

            <p className="text-[10px] text-white/60 leading-relaxed max-w-sm mt-1.5">
              Join a global community of solo travelers who share your passion for adventure and exploration.
            </p>

   


          </div>
        </div>
      </div>
    </section>
  );
}